// extracted by mini-css-extract-plugin
export default {"newsList":"index_newsList_jpdIQ","fontBolder":"index_fontBolder_Cs-MU"};